"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionDetails = void 0;
const react_1 = __importDefault(require("react"));
const AccordionDetails_1 = __importDefault(require("@material-ui/core/AccordionDetails"));
/**
 *
 * This is meant to hold the contents in the expanded portion of the accordion.
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
const AccordionDetails = ({ children }) => (react_1.default.createElement(AccordionDetails_1.default, null,
    react_1.default.createElement(react_1.default.Fragment, null, children)));
exports.AccordionDetails = AccordionDetails;
exports.default = exports.AccordionDetails;
